import { FaArrowLeftLong, FaRegPenToSquare } from "react-icons/fa6";
import "./bag.css";
import { useNavigate } from "react-router-dom";
import { HiMiniXCircle } from "react-icons/hi2";
import { FaTrashAlt } from "react-icons/fa";
import CART from "../assests/1.png";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Address from "../Components/USER/Address";

const Bag = ({ bag, updateQuantity, remove, profile, profileupdate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [selectedAddress, setSelectedAddress] = useState(null);

  const navigate = useNavigate();

  const removes = (option, id) => {
    remove(option, id, "cart");
  };

  const calculateTotal = () => {
    return bag
      .reduce((total, item) => {
        const price = getItemPrice(item);
        const quantity = parseInt(item.quantity) || 0;
        const taxPercent = parseFloat(item.tax) || 0;

        const baseAmount = price * quantity;
        const taxAmount = (baseAmount * taxPercent) / 100;

        return total + baseAmount + taxAmount;
      }, 0)
      .toFixed(2);
  };


  const getItemPrice = (item) => {
    const priceString = item?.discounted_amount || item.prod_price;
    return parseFloat(priceString.replace(/,/g, "")) || 0;
  };

  const getItemTaxAmount = (item) => {
    const price = getItemPrice(item);
    const quantity = parseInt(item.quantity) || 0;
    const taxPercent = parseFloat(item.tax) || 0;

    return (price * quantity * taxPercent) / 100;
  };

  const getItemTotalWithTax = (item) => {
    const price = getItemPrice(item);
    const quantity = parseInt(item.quantity) || 0;
    const taxAmount = getItemTaxAmount(item);

    return price * quantity + taxAmount;
  };

  const handlehome = () => {
    navigate("/");
  };

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  const handleplaceorder = async () => {
    if (!paymentMethod) {
      toast.warning("please select the payment method");
      return;
    }

    if (!selectedAddress) {
      toast.warning("Please select an address");
      return;
    }

    const formData = new FormData();

    formData.append("cust_id", userData?.id);
    const prodIds = bag.map((item) => item.product_id).join(",");
    const sizes = bag.map((item) => item.prod_size).join(",");
    const quantities = bag.map((item) => item.quantity).join(",");
    const prices = bag.map((item) => item.prod_price).join(",");

    // Append to formData
    formData.append("prod_id", prodIds);
    formData.append("size", sizes);
    formData.append("quantity", quantities);
    formData.append("price", prices);

    // value
    formData.append("total_amount", totalAmount);
    formData.append("address", selectedAddress);
    formData.append("order_status", "In Progress");
    formData.append("payment_status", "Pending");
    formData.append("phone_no", phoneNumber);

    formData.append("payment_method", paymentMethod);
    formData.append("transaction_id", paymentMethod);
    formData.append("payment_gateway", paymentMethod);
    formData.append("coupon_id", "");

    try {
      setIsLoading(true);

      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/order_add.php`,
        formData
      );

      const message = res.data?.message;

      if (res.data?.status === "success") {
        toast.success("Order placed successfully!", {
          className: "custom-toast",
          autoClose: 3000,
        });
        removes("clear");
      } else {
        toast.error(message || "Something went wrong", {
          className: "custom-toast custom-toast-error",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error("Failed to place order. Please try again.", {
        className: "custom-toast custom-toast-error",
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const [totalAmount, setTotalAmount] = useState("0.00");

  useEffect(() => {
    const total = calculateTotal();
    setTotalAmount(total);
  }, [bag]);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    if (profile?.phone_no) {
      setPhoneNumber(profile.phone_no);
    }
    if (profile?.company_name && profile?.gst_no && profile?.billing_add &&
      profile?.billing_add && profile?.name && profile?.phone_no && profile?.email) {
      setQuotationDeatils({
        GstName: profile?.company_name,
        GstNumber: profile?.gst_no,
        BillingAddress: profile?.billing_add,
        ShippingAddress: profile?.billing_add,
        ReciverName: profile?.name,
        Reciverph: profile?.phone_no,
        Reciveremail: profile?.email,
      })
    }
  }, [profile?.phone_no && profile?.company_name && profile?.gst_no && profile?.billing_add &&
    profile?.billing_add && profile?.name && profile?.phone_no && profile?.email]);

  const handleSaveClick = () => {
    if (!phoneNumber.trim()) {
      setPhoneError("Phone number is required");
      return;
    }
    if (!/^[0-9]{10}$/.test(phoneNumber)) {
      setPhoneError("Please enter a valid 10-digit phone number");
      return;
    }
    setPhoneError("");
    setIsEditingPhone(false);

    // Proceed with saving, e.g.
    // formData.append("ph", phoneNumber);
  };

  const [isQuotationFormOpen, setisQuotationFormOpen] = useState(false);
  const [QuotationDeatils, setQuotationDeatils] = useState({
    GstName: "",
    GstNumber: "",
    BillingAddress: "",
    ShippingAddress: "",
    ReciverName: "",
    Reciverph: "",
    Reciveremail: "",
  })

  const handleQuotation = () => {
    setisQuotationFormOpen(true)
  }

  const handleGetQuotation = async (e) => {
    e.preventDefault();

    try {
      const cust_id = userData?.id;
      const company_name = QuotationDeatils?.GstName;
      const contact_person_name = QuotationDeatils?.ReciverName;
      const gst_number = QuotationDeatils?.GstNumber;
      const contact_person_email = QuotationDeatils?.Reciveremail;
      const contact_person_phone = QuotationDeatils?.Reciverph;
      const billing_address = QuotationDeatils?.BillingAddress;
      const shipping_address = QuotationDeatils?.ShippingAddress;
      const total_amount = totalAmount;

      let productParams = "";

      bag.forEach((item, index) => {
        productParams +=
          `&product_name[${index}]=${encodeURIComponent(item.prod_name)}` +
          `&size[${index}]=${encodeURIComponent(item.prod_size)}` +
          `&quantity[${index}]=${encodeURIComponent(item.quantity)}` +
          `&price[${index}]=${encodeURIComponent(item.prod_price)}` +
          `&product_price[${index}]=${encodeURIComponent(getItemTotalWithTax(item))}` +
          `&tax[${index}]=${encodeURIComponent(item.tax)}`;
      });


      const url = `${process.env.REACT_APP_BASEURL}/apis/vendor/quotation_pdf.php?` +
        `cust_id=${encodeURIComponent(cust_id)}` +
        `&company_name=${encodeURIComponent(company_name)}` +
        `&contact_person_name=${encodeURIComponent(contact_person_name)}` +
        `&gst_number=${encodeURIComponent(gst_number)}` +
        `&contact_person_email=${encodeURIComponent(contact_person_email)}` +
        `&contact_person_phone=${encodeURIComponent(contact_person_phone)}` +
        `&billing_address=${encodeURIComponent(billing_address)}` +
        `&shipping_address=${encodeURIComponent(shipping_address)}` +
        `&total_amount=${encodeURIComponent(total_amount)}` +
        productParams;

      const response = await fetch(url, { method: "GET" });
      const data = await response.json();
      if (data?.status === "success") {
        toast.success("Quotation Successfully Sent to your E-mail", {
          className: "custom-toast",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };

  return (
    <div>
      {bag.length !== 0 && (
        <div className="outer-div">
          <div className="cart-container">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "13.8px",
                maxWidth: "550px",
              }}
            >
              {/* <h2 className="cart2"> */}
              {bag.length > 0 && (
                <>
                  <h2 className="cart1">Shopping Cart</h2>
                  <h2 className="cart2">
                    {bag.reduce(
                      (total, item) => total + parseInt(item.quantity),
                      0
                    )}{" "}
                    {bag.reduce(
                      (total, item) => total + parseInt(item.quantity),
                      0
                    ) === 1
                      ? "Item"
                      : "Items"}
                  </h2>
                </>
              )}
              {/* </h2> */}
            </div>
            <div className="line"></div>
            {bag.length !== 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: "column",
                }}
              >
                <div className="empty-cart-container">
                  <button
                    className="get-quotation-btn"
                    onClick={handleQuotation}
                  >
                    Get Quotation <FaRegPenToSquare />
                  </button>
                  <button
                    className="empty-cart-btn"
                    onClick={() => {
                      removes("clear");
                    }}
                  >
                    Empty <FaTrashAlt />
                  </button>
                </div>

                <div className="cart-items">
                  <table className="cart-table">
                    <thead>
                      <tr>
                        {/* <th>Image</th> */}
                        <th></th>
                        <th>Product Details</th>
                        <th>Size</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Tax</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bag.map((item) => (
                        <tr key={item.id}>
                          <td style={{ alignContent: "center" }}>
                            <button
                              className="bag-remove-btn"
                              onClick={() => removes("delete", item.id)}
                            >
                              <HiMiniXCircle />
                            </button>
                          </td>
                          <td style={{ display: "flex" }}>
                            <img
                              src={`${process.env.REACT_APP_BASEURL
                                }/apis/vendor/uploads/products/${item.prod_img.split(",")[0]
                                }`}
                              alt={item.prod_name}
                              className="cart-item-image"
                            />
                            <h4>{item.prod_name}</h4>
                          </td>
                          <td>
                            <span>{item.prod_size}</span>
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              minimumFractionDigits: 2,
                            }).format(
                              parseFloat(
                                (
                                  item?.discounted_amount || item.prod_price
                                ).replace(/,/g, "")
                              ) || 0
                            )}
                          </td>

                          <td>
                            <div className="quantity-controls">
                              <button
                                onClick={() =>
                                  updateQuantity(item.id, -1, "cart")
                                }
                              >
                                -
                              </button>
                              <span>{item.quantity}</span>
                              <button
                                onClick={() =>
                                  updateQuantity(item.id, 1, "cart")
                                }
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td>{item?.tax}</td>
                          <td>
                            <td>
                              {new Intl.NumberFormat("en-IN", {
                                style: "currency",
                                currency: "INR",
                                minimumFractionDigits: 2,
                              }).format(getItemTotalWithTax(item))}
                            </td>

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{ width: "max-content" }}>
                  <div className="backto" onClick={handlehome}>
                    <FaArrowLeftLong /> continue to shopping
                  </div>
                </div>
              </div>
            )}

            {isQuotationFormOpen &&
              <div className="modal-overlay">
                <div className="modal-box" style={{ maxWidth: "700px" }}>
                  <h3>Quotation Details</h3>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "100%", }}>
                      <div>
                        <label>Company Name</label>
                        <input
                          type="text"
                          value={QuotationDeatils?.GstName}
                          readOnly
                        />
                      </div>
                      <div>
                        <label>GST Number</label>
                        <input
                          type="text"
                          value={QuotationDeatils?.GstNumber}
                          readOnly
                        />
                      </div>
                      <div>
                        <label>Billing Address</label>
                        <input
                          type="text"
                          value={QuotationDeatils?.BillingAddress}
                          readOnly
                        />
                      </div>
                      <div>
                        <label>Shipping Address</label>
                        <input
                          type="text"
                          value={QuotationDeatils?.ShippingAddress}
                          onChange={(e) => setQuotationDeatils((pv) => ({ ...pv, ShippingAddress: e.target.value }))}
                        />
                      </div>

                    </div>
                    <div className="row" style={{ width: "100%", }}>
                      <div>
                        <label>Contact Person`s Name</label>
                        <input
                          type="text"
                          value={QuotationDeatils?.ReciverName}
                          onChange={(e) => setQuotationDeatils((pv) => ({ ...pv, ReciverName: e.target.value }))}
                        />
                      </div>
                      <div>
                        <label>Contact Person`s Email</label>
                        <input
                          type="text"
                          value={QuotationDeatils?.Reciveremail}
                          onChange={(e) => setQuotationDeatils((pv) => ({ ...pv, Reciveremail: e.target.value }))}
                        />
                      </div>
                      <div>
                        <label>Contact Person`s Phone Number</label>
                        <input
                          type="text"
                          value={QuotationDeatils?.Reciverph}
                          onChange={(e) => setQuotationDeatils((pv) => ({ ...pv, Reciverph: e.target.value }))}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="confirm-buttons">
                    <button
                      type="button"
                      className="no-btn"
                      onClick={handleGetQuotation}
                    >
                      Send By Email
                    </button>
                    <button
                      className="yes-btn"
                      onClick={() => setisQuotationFormOpen(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>

          {bag.length > 0 && (
            <div className="order-summary">
              <div className="cart-total">
                <div className="cart1">Order Summary</div>
              </div>
              <div className="line"></div>

              <div style={{ position: "relative", left: "10px" }}>
                <div className="summary-price">
                  {/* <p className="cart3">
                {bag.reduce(
                  (total, item) => total + parseInt(item.quantity),
                  0
                )}{" "}
                {bag.reduce(
                  (total, item) => total + parseInt(item.quantity),
                  0
                ) === 1
                  ? "Item"
                  : "Items"}
              </p> 
              <p className="cart3"> Rs.{calculateTotal()}</p>*/}
                </div>

                <div
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    padding: "12px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    maxWidth: "400px",
                    // backgroundColor: "#f9f9f9",
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Registered Phone Number
                  </label>

                  {isEditingPhone ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <input
                          type="tel"
                          pattern="[0-9]{10}"
                          maxLength={10}
                          title="Please enter a valid 10-digit phone number"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          placeholder="Enter phone number"
                          style={{
                            padding: "8px",
                            fontSize: "14px",
                            flex: 1,
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                          }}
                        />

                        <button
                          type="button"
                          onClick={handleSaveClick}
                          style={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            border: "none",
                            padding: "6px 12px",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                        >
                          Save
                        </button>
                      </div>
                      {phoneError && (
                        <p style={{ color: "red", marginTop: 5 }}>
                          {phoneError}
                        </p>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <p style={{ margin: 0 }}>
                        {phoneNumber?.trim().length > 0
                          ? phoneNumber
                          : "No number added"}
                      </p>
                      <button
                        onClick={() => setIsEditingPhone(true)}
                        style={{
                          backgroundColor: "#ffc107",
                          color: "#000",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
                      >
                        Edit
                      </button>
                    </div>
                  )}
                </div>

                <div>
                  <Address
                    profileupdate={profileupdate}
                    profile={profile}
                    onSelectAddress={(address) => setSelectedAddress(address)}
                  />
                </div>

                <div>
                  <p className="cart3">Payment Method</p>
                  <select
                    className="cart4"
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  >
                    <option className="cart44" value="" disabled>
                      Select any one
                    </option>
                    <option className="cart44" value="cod">
                      Cash On Delivery
                    </option>
                    <option className="cart44" value="UPI" >
                      Net Banking
                    </option>
                    <option className="cart44" value="UPI" disabled>
                      UPI
                    </option>
                    <option className="cart44" value="UPI" disabled>
                      Credit/Debit Card
                    </option>
                    <option className="cart44" value="UPI" disabled>
                      EMI
                    </option>
                  </select>
                </div>

                {/* <p className="cart3">Promo Code</p>
                  <input type="text" className="cart4" /> */}
                <div className="line"></div>
                <div className="tot">
                  <h3>Total Amount</h3>
                  <p className="cart3">
                    {new Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(totalAmount)}
                  </p>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <button className="checkout-btn" onClick={handleplaceorder}>
                  Place Order
                </button>
              </div>
              {isLoading && (
                <div className="loading-overlay">
                  <div className="spinner"></div>
                  <p className="loading-text">Confirming your order...</p>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {bag.length === 0 && (
        <>
          <div className="mt-cart-container">
            <img src={CART} alt="Empty Cart" className="empty-cart-image" />
            <button className="go-shopping-btn" onClick={() => navigate("/")}>
              🛍️ Go Shopping
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Bag;
